export const COLOR = {
  BLUE: '#397ccb',
  GREY_LIGHTEST: '#e8edf0',
  GREY_LIGHTER: '#d7dcdf',
  GREY_LIGHT: '#c1c4c7',
  GREY: '#a0a4a7',
  GREY_DARK: '#6d7073',
}
